import React, { ComponentType } from 'react'
import { Segment } from 'semantic-ui-react'
// Local
import { Patient } from '../../patient/patient'

const SafeSegment = Segment as unknown as ComponentType<any>

type Props = {
  mode?: string | undefined
  patient?: Patient | undefined
}

function VbcProgram(
  props: Props
): JSX.Element | null {
  const {
    mode = 'left',
    patient
  } = props

  if (mode !== 'left') return null

  if (patient && patient.vbcProgram) {
    return (
      <SafeSegment
        attached
        compact
        className="left-segment"
      >
        <div className="left-title">
          VBC Program:
        </div>
        <div className="left-content">
          { patient.vbcProgram }
        </div>
      </SafeSegment>
    )
  }

  return null
}

export default VbcProgram
